import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  static targets = ["list"];

  connect() {
    this.render();
  }

  render() {
    const allHeadings = Array.from(document.querySelectorAll("h2, h3, h4, h5"));
    const missing = allHeadings.filter((h) => !h.id);
    if (missing.length > 0) {
      console.warn(
        "[toc] headings without id:",
        missing.map((h) => h.textContent.trim())
      );
    }
    const headings = allHeadings.filter((h) => h.id);
    this.listTarget.innerHTML = "";
    if (headings.length === 0) {
      this.element.style.display = "none";
      return;
    }

    this.element.style.display = "";

    const levels = headings.map((h) => parseInt(h.tagName[1]));
    const minLevel = Math.min(...levels);

    headings.forEach((heading) => {
      const level = parseInt(heading.tagName[1]);
      const item = document.createElement("li");
      item.style.paddingLeft = `${(level - minLevel) * 0.75}rem`;

      const link = document.createElement("a");
      link.href = `#${heading.id}`;
      link.textContent = heading.textContent;
      link.className = "toc-link";

      item.appendChild(link);
      this.listTarget.appendChild(item);
    });
  }
}
